<template>
    <form @submit.prevent="pay">
        <slot :fields="fieldData" :updateField="updateField"></slot>
    </form>
</template>
<script>
import {loadPaymentScripts, startTransaction} from "../datatrans";
import {onBeforeMount, reactive} from "vue";

export default {
    props: {
        action: {
            required: true,
            type: String,
        },
        testing: {
            required: true,
            type: Boolean
        },
        fields: {
            required: false,
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    setup({testing, fields, action}) {
        let fieldData = reactive(Object.assign({}, fields));
        let updateField = (name, value) => {
            if (!(name in fields)) {
                throw Error(`Fields should set a default value for ${name}`)
            }
            fieldData[name] = value;
        }

        let pay = () => startTransaction(action, fieldData);

        let newsletterChecked = () => {
            return fieldData.newsletter === true;
        }

        onBeforeMount(() => {
            loadPaymentScripts(testing);
        });

        return {
            fieldData,
            updateField,
            pay,
            newsletterChecked
        }
    },
}
</script>
